import { FreeSpaceJudgeDetailPresenter } from '@/presentation/presenters/freeSpace/freeSpaceJudgeDetailPresenter'
import { FreeSpaceJudgeDetailViewModel } from '@/presentation/viewmodels/freeSpace/freeSpaceJudgeDetailViewModel'

export function useFreeSpaceJudgeDetailPresenter(
  presenter: FreeSpaceJudgeDetailPresenter = new FreeSpaceJudgeDetailPresenter(new FreeSpaceJudgeDetailViewModel())
) {
  return {
    judgeDetail: presenter.judgeDetail
  }
}
